export { default } from "./src/design-refresh-heading";

export type { UniformDesignRefreshHeadingProps } from "./src/design-refresh-heading";
